import React, { useEffect, useState } from "react";
import { ExternalLink, FileAudio, FileText, Library, Link as LinkIcon, Video } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const ICONS = { document: FileText, video: Video, audio: FileAudio, link: LinkIcon };

const AcademyMaterials = () => {
  const [rows,setRows] = useState([]);
  const [error,setError] = useState("");
  useEffect(() => {
    api.get("/api/academy/materials").then(({data}) => setRows(Array.isArray(data) ? data : [])).catch((e) => setError(formatApiError(e)));
  }, []);
  const grouped = rows.reduce((acc,row) => { (acc[row.course_title] ||= []).push(row); return acc; }, {});

  return (
    <div className="mx-auto max-w-[1450px] pb-12" data-testid="academy-materials-page">
      <section className="relative mb-6 overflow-hidden rounded-[30px] border border-[#d4ab5e]/20 bg-[#0d0b08] p-6 md:p-8">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_15%,rgba(212,171,94,.14),transparent_34%)]" />
        <div className="relative">
          <div className="flex items-center gap-2 font-mont text-[8px] uppercase tracking-[.3em] text-[#aa956e]"><Library size={12}/> Biblioteca KD9</div>
          <h1 className="mt-2 font-cinzel text-3xl text-[#f1dcae] md:text-4xl">Archivo del conocimiento</h1>
          <p className="mt-3 max-w-3xl font-cormorant text-xl text-[#b3a895]">Recursos protegidos habilitados exclusivamente por los senderos académicos que ya tienes activos.</p>
        </div>
      </section>
      {error && <div className="mb-5 rounded-2xl border border-red-400/20 bg-red-950/20 p-4 font-mont text-sm text-red-200">{error}</div>}
      {!rows.length ? <div className="rounded-[26px] border border-white/8 bg-white/[.02] p-12 text-center font-cormorant text-xl text-[#a99d89]">Aún no tienes materiales habilitados.</div> :
        Object.entries(grouped).map(([course,materials]) => (
          <section key={course} className="mb-8">
            <div className="mb-4 font-cinzel text-xl text-[#ead5aa]">{course}</div>
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{materials.map((material) => {
              const Icon = ICONS[material.kind] || FileText;
              return <article key={material.id} className="rounded-[22px] border border-white/9 bg-[#100d09] p-5">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-[#d4ab5e]/20 bg-[#d4ab5e]/6 text-[#c5a463]"><Icon size={20}/></div>
                <h3 className="mt-4 font-cinzel text-lg text-[#ead5aa]">{material.title}</h3>
                <p className="mt-2 font-cormorant text-base text-[#a99d89]">{material.description}</p>
                <a href={material.url} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 rounded-xl border border-[#d4ab5e]/25 px-4 py-2.5 font-mont text-[8px] uppercase tracking-[.13em] text-[#dec17f]">Abrir recurso <ExternalLink size={11}/></a>
              </article>;
            })}</div>
          </section>
        ))}
    </div>
  );
};
export default AcademyMaterials;
